// extracted by mini-css-extract-plugin
export default {"status":"status-cell-render_status__pQlJk"};